/* eslint-disable react-native/no-inline-styles */
import React, { useState } from 'react';
import { View, Text, ScrollView } from 'react-native';
import i18n from 'i18n-js';

import { scale, width } from '@components/frame';
import { Alert, isPhone, localTime } from '@helpers';

import { font } from '@styles/fonts';
import { getBoxShadowStyle } from '@styles/shadow';

import Line from '@components/common/line';
import TouchableElement from '@components/common/touchableElement';
import LineButton from '@components/common/lineButton';
import { modalFieldBg, SCREEN_BORDER_RADIUS } from '@v2/pages/common/constants/base.constants';

export default (props) => {
  const { C, hide, clampingTool, tool, setEditConfig, params = {}, setMode, MODES, getClampingTools, remove, removeClampingTool, newTool } = props;
  const [deletingClamping, setDeletingClamping] = useState(false);
  const [deletingTool, setDeletingTool] = useState(false);

  const triggerDelete = async (FN) => {
    Alert({
      title: i18n.t('Are you sure?'),
      actions: [
        {
          text: i18n.t('No'),
          onPress: () => {},
          style: 'primary',
        },
        {
          text: i18n.t('Yes'),
          onPress: async () => {
            await FN();
          },
        },
      ],
    });
  };

  const deleteTool = async () => {
    setDeletingTool(true);
    const result = await remove({
      toolId: tool.toolId,
    });
    await getClampingTools();
    setDeletingTool(false);
    if (result) {
      hide();
    }
  };

  const deleteClampingTool = async () => {
    setDeletingClamping(true);
    const result = await removeClampingTool({
      clampingToolId: clampingTool.clampingToolId,
    });
    setDeletingClamping(false);
    if (result) {
      hide();
    }
  };

  const toolDetails = [
    {
      value: tool.description,
      name: i18n.t('Description'),
      valueName: 'description',
    },
    {
      value: tool.memo,
      name: i18n.t('Memo'),
      valueName: 'memo',
    },
    {
      value: tool.stickoutMM,
      name: `${i18n.t('Stickout')} ${i18n.t('mm')}`,
      valueName: 'stickoutMM',
      keyboardType: 'number-pad',
    },
  ];

  const ncDetails = [
    {
      value: 5,
      name: i18n.t('NC Files'),
    },
  ];

  const shadowStyles = getBoxShadowStyle({ type: 'Field', C });

  return (
    <View style={{ width: isPhone ? width : '100%' }}>
      <View
        style={{
          width: '100%',
          zIndex: 1000,
          height: scale(52),
        }}
      >
        <View style={{ position: 'absolute', zIndex: 1000, right: 0 }}>
          <TouchableElement onPress={() => setMode(newTool ? MODES.SELECT_TOOL : MODES.CLAMPING_TOOL_DETAILS)}>
            {({ boxStyle, pressHoverColor }) => (
              <View style={[boxStyle, { padding: scale(15) }]}>
                <Text style={[{ color: C(pressHoverColor('Link/Light/Primary')) }, font.Headline]}>{i18n.t('Done')}</Text>
              </View>
            )}
          </TouchableElement>
        </View>
        <View style={{ width: '100%', position: 'absolute', zIndex: 100, top: scale(15) }}>
          <Text style={[{ color: C('Label/Light/Primary'), width: '100%', textAlign: 'center' }, font.Headline]}>
            <Text style={[font.Headline, { color: C('Label/Light/Primary') }]}>{tool?.toolName}</Text>
          </Text>
        </View>
      </View>
      <ScrollView contentContainerStyle={{ width: '100%' }}>
        <View
          style={{
            width: '100%',
            marginTop: scale(31),
            paddingHorizontal: scale(15),
            paddingBottom: scale(15),
          }}
        >
          <View style={[shadowStyles, { borderRadius: scale(SCREEN_BORDER_RADIUS) }]}>
            {toolDetails.map((item, index) => (
              <Line
                {...{
                  item: {
                    ...item,
                    onClick: () => {
                      setEditConfig({
                        header: item.name,
                        initData: {
                          [item.valueName]: String(tool[item.valueName] || ''),
                        },
                        inputs: [
                          {
                            key: item.valueName,
                            isLable: false,
                            noArrow: true,
                            placeholder: item.name,
                            keyboardType: item.keyboardType,
                          },
                        ],
                      });
                      setMode(MODES.EDIT_TOOL_DETAILS);
                    },
                  },
                  bg: modalFieldBg,
                  index,
                  array: toolDetails,
                  C,
                  roundTop: index === 0,
                  roundBottom: toolDetails.length - 1 === index,
                }}
                key={item.valueName}
              />
            ))}
          </View>
          <View style={{ marginTop: scale(20) }}>
            <LineButton
              {...{
                C,
                onPress: () => {
                  if (deletingClamping) {
                    return;
                  }
                  triggerDelete(deleteClampingTool);
                },
                bg: modalFieldBg,
                loading: deletingClamping,
                text: i18n.t('Remove'),
                color: 'Link/Light/Primary',
              }}
            />
          </View>
          <View style={{ marginTop: scale(6), marginHorizontal: scale(15) }}>
            <Text
              style={[
                {
                  color: C('Label/Light/Tertiary'),
                },
                font['Caption 1'],
              ]}
            >
              {i18n.t('Remove')} {tool?.toolName} {i18n.t('from')} {params.ncFile}
            </Text>
          </View>
          <View style={{ marginTop: scale(28), marginLeft: scale(15) }}>
            <Text
              style={[
                {
                  color: C('Label/Light/Tertiary'),
                },
                font.Footnote,
              ]}
            >
              {i18n.t('WHERE USED')}
            </Text>
          </View>
          <View style={[shadowStyles, { marginTop: scale(5), borderRadius: scale(SCREEN_BORDER_RADIUS) }]}>
            {ncDetails.map((item, index) => (
              <Line
                {...{
                  item,
                  index,
                  array: ncDetails,
                  C,
                  roundTop: index === 0,
                  roundBottom: ncDetails.length - 1 === index,
                  bg: modalFieldBg,
                }}
                key={item.name}
              />
            ))}
          </View>
          <View style={{ marginTop: scale(30) }}>
            <LineButton
              {...{
                C,
                onPress: () => {
                  if (deletingTool) {
                    return;
                  }
                  triggerDelete(deleteTool);
                },
                loading: deletingTool,
                text: i18n.t('Delete'),
                color: 'Label / Light / Error',
                bg: modalFieldBg,
              }}
            />
          </View>
          <View style={{ marginTop: scale(6), marginHorizontal: scale(15) }}>
            <Text
              style={[
                {
                  color: C('Label/Light/Tertiary'),
                },
                font['Caption 1'],
              ]}
            >
              {i18n.t('Delete')} {tool?.toolName} {i18n.t('in tool library and remove it from all NC Files')}.
            </Text>
          </View>
          <View style={{ marginTop: scale(26), marginHorizontal: scale(15) }}>
            <Text
              style={[
                {
                  color: C('Label/Light/Tertiary'),
                },
                font['Caption 1'],
              ]}
            >
              {i18n.t('Last modified on')} {localTime(tool.lastModifiedOn).format('DD-MM-YYYY')} {i18n.t('by')} {tool.lastModifiedByUser}
            </Text>
            <Text
              style={[
                {
                  color: C('Label/Light/Tertiary'),
                },
                font['Caption 1'],
              ]}
            >
              {i18n.t('Created on')} {localTime(tool.createdOn).format('DD-MM-YYYY')} {i18n.t('by')} {tool.createdByUser}
            </Text>
          </View>
        </View>
      </ScrollView>
    </View>
  );
};
